import { ReactNode, createContext, default as React, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { WorkersReducer } from "../reducers/WorkersReducer";

const WorkersContext = createContext({
	state: WorkersReducer.getInitialState(),
	actions: WorkersReducer.actions,
});

export const useWorkersContext = () => useContext(WorkersContext);

export const WorkersProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: WorkersReducer.getInitialState(),
		reducers: WorkersReducer.caseReducers,
	});

	return (
		<WorkersContext.Provider value={{ state, actions }}>
			{children}
		</WorkersContext.Provider>
	);
};
